import type { SxProps, Theme } from '@mui/material';
import { SvgIcon } from '@mui/material';

interface AppLogoProps {
  size?: number;
  sx?: SxProps<Theme>;
}

export function AppLogo({ size = 32, sx }: AppLogoProps) {
  return (
    <SvgIcon
      viewBox="0 0 1000 1000"
      sx={{ width: size, height: size, ...sx as object }}
    >
      <path
        fill="#1c72f3"
        d="M15.68 499.5q0-20.92.26-25.29Q23.98 334.74 103.66 220.94C187.83 100.75 325.69 23.61 471.96 16.22q28.18-1.42 62.24.28 9.58.48 17.87 1.62c8.79 1.2 15.54 1.78 23.75 3.11Q685.91 39.06 776.28 101.86c73.34 50.97 131.6 121.51 167.59 203.41q35.5 80.77 40.15 170.68.22 4.22.22 24.51 -.01 20.92-.26 25.29Q975.94 665.22 896.26 779.02C812.09 899.21 674.23 976.35 527.96 983.74q-28.18 1.42-62.24-.28-9.58-.48-17.87-1.62c-8.79-1.2-15.54-1.78-23.75-3.11Q314.01 960.9 223.64 898.1C150.3 847.13 92.04 776.59 56.05 694.69Q20.55 613.92 15.89 524.01q-.22-4.22-.21-24.51z"
      />
      <path
        fill="#ffffff"
        d="M361.64 638.13c.02.01.17.11.18.11Q531.38 638.25 731.53 638.14a.41.41 0 01.41.41v92.74a.46.46 0 01-.46.46Q465.13 731.88 268.36 731.87q-.08 0-.25-.16-.16-.17-.16-.25-.11-196.77 0-463.12a.46.46 0 01.46-.46l92.62-.05a.41.41 0 01.41.41Q361.43 468.39 361.54 637.95c0 .02.09.17.1.18z"
      />
      <rect fill="#ffffff" x="407.85" y="268.11" width="324.14" height="93.44" rx=".49" />
      <rect fill="#ffffff" x="407.84" y="453.48" width="324.14" height="93.48" rx=".6" />
    </SvgIcon>
  );
}
